//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'SideBar',
    data () {
        return{
            sideTop:true,
            sidePreviousScroll:true,
        }
    },
    mounted() {
        setTimeout(() => {
            if (window.innerWidth > 992){
                window.addEventListener('scroll', this.stickNavbar);
            }
        }, 500);
    },

    methods: {
        stickNavbar () {
            let currentScroll = window.scrollY
            let body = document.body,
                html = document.documentElement;

            let height = Math.max(body.scrollHeight,body.offsetHeight,html.clientHeight,html.scrollHeight,html.offsetHeight);
            if (currentScroll > 10 && currentScroll < height - screen.height){
                if (currentScroll > this.sidePreviousScroll){
                    this.sideTop = true
                } else {
                    this.sideTop = false
                }
                this.sidePreviousScroll = currentScroll;
            }
        },
    },

    destroyed () {
        window.removeEventListener('scroll', this.stickNavbar);
    },
}
